export var ProductEnvironment = /*#__PURE__*/function (ProductEnvironment) {
  ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
  ProductEnvironment["STAGING"] = "STAGING";
  ProductEnvironment["PRODUCTION"] = "PRODUCTION";
  return ProductEnvironment;
}({});
export var ForgeCDNEnvironment = /*#__PURE__*/function (ForgeCDNEnvironment) {
  ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
  ForgeCDNEnvironment["STAGING"] = "stg";
  ForgeCDNEnvironment["PRODUCTION"] = "prod";
  ForgeCDNEnvironment["FEDRAMP_SANDBOX"] = "fex";
  return ForgeCDNEnvironment;
}({});